var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V69.3333H496V16Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 69.333H16V122.666H496V69.333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 122.667H16V176H496V122.667Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 176H16V229.333H496V176Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 229.333H16V282.666H496V229.333Z",
    fill: "#2980B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 282.666H16V335.999H496V282.666Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496 336H16V389.333H496V336Z",
    fill: "#2980B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M496 389.333H16V442.666H496V389.333Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M496 442.667H16V496H496V442.667Z",
    fill: "#2980B9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M233.284 16H16V282.667H233.284V16Z",
    fill: "#2980B9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M151.808 16.4883H97.4761V282.178H151.808V16.4883Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.977096
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.843 176.546V122.12H16.4414V176.546H232.843Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.882587
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/GR.e943221abc99a5f45d6a640dd363d420.svg";
export { ForwardRef as ReactComponent };